import { Building2, FolderKanban, IdCard } from "lucide-react";
import { useCompany } from "@/hooks/useCompanies";
import { useProjects } from "@/hooks/useProjects";
import { matchContextPath } from "../match";
import type { ContextParams, NavContextDef, NavItem } from "../types";

export const companyPath = (id: string) => `/companies/${id}`;

function useCompanyItems({ id }: ContextParams): NavItem[] {
  const base = companyPath(id);
  // L6: the project count moves from the tab to the sidebar item.
  const { data: projects } = useProjects();
  const projectCount = projects
    ? projects.filter((p) => p.customer_id === id).length
    : null;
  return [
    { key: "details", label: "Details", href: base, exact: true, icon: IdCard },
    {
      key: "projects",
      label: "Projects",
      href: `${base}/projects`,
      icon: FolderKanban,
      badge: projectCount,
    },
  ];
}

function useCompanyHeader({ id }: ContextParams) {
  const { data: company } = useCompany(id);
  if (!company) return {};
  return { title: company.name };
}

export const companyContext: NavContextDef = {
  type: "company",
  typeLabel: "Company",
  icon: Building2,
  match: (pathname) =>
    matchContextPath("/companies/:id", pathname, { id: ["new"] }),
  key: ({ id }) => `company:${id}`,
  base: ({ id }) => companyPath(id),
  parent: () => ({ label: "Companies", href: "/companies" }),
  useHeader: useCompanyHeader,
  useItems: useCompanyItems,
};
